export const common = {
  // Navigation
  home: 'Inicio',
  fleet: 'Flota',
  services: 'Servicios',
  about: 'Sobre Nosotros',
  contact: 'Contacto',
  contacts: 'Contactos',
  
  // Buttons
  bookNow: 'Reservar Ahora',
  viewFleet: 'Ver Flota',
  requestQuote: 'Solicitar Presupuesto',
  getQuote: 'Obtener Presupuesto',
  submit: 'Enviar',
  
  // Hero Section
  heroTitle: 'Reserve hoy su transfer sin estrés y ahorre hasta un 40%',
  heroSubtitle: 'Te conectamos al Aeropuerto de Faro con comodidad y seguridad',
  heroMainTitle: 'Transfers Aeropuerto Faro Algarve',
  heroMainSubtitle: 'Licenciados y Asegurados 24/7',
  heroServiceTitle: 'Transfers Totalmente Licenciados y Asegurados • Disponible 24/7',
  heroServiceSubtitle: 'Servicio premium desde el Aeropuerto de Faro a todo el Algarve con precios fijos garantizados',
  heroBenefit1: 'Licenciados',
  heroBenefit2: 'Asegurados',
  heroBenefit3: 'Precios Fijos',
  heroCtaBook: 'Reservar Ahora',
  heroCtaPricing: 'Ver Precios',
  heroTrust1: '4.9★ Calificación',
  heroTrust2: '5000+ Clientes',
  heroTrust3: 'Disponible 24/7',
  
  // Services Section - Main
  servicesTitle: 'Nuestros Servicios',
  servicesSubtitle: 'Ofrecemos una gama completa de servicios de transporte para hacer tu estancia en Algarve inolvidable',
  servicesMainTitle: 'Servicios de Transfer Low Cost',
  servicesMainSubtitle: 'Transfers confiables desde el Aeropuerto de Faro a todo el Algarve. Servicio licenciado, asegurado y disponible 24/7.',
  
  // Services - Individual Cards
  service1Title: 'Transfers Aeropuerto',
  service1Desc: 'Servicio de transfer desde/hacia el Aeropuerto de Faro con puntualidad garantizada y monitoreo de vuelos en tiempo real.',
  service1Keywords: 'Transfer Aeropuerto Faro, Taxi Aeropuerto, Transporte Aeropuerto',
  service1Feature1: 'Monitoreo de vuelos',
  service1Feature2: 'Conductor esperando',
  service1Feature3: 'Sin costos de espera',
  
  service2Title: 'Transfers Privados',
  service2Desc: 'Transporte privado y exclusivo a cualquier destino en Algarve. Comodidad, privacidad y flexibilidad total.',
  service2Keywords: 'Transfer Privado Algarve, Transporte Privado, Viaje Exclusivo',
  service2Feature1: 'Conocimiento local',
  service2Feature2: 'Rutas optimizadas',
  service2Feature3: 'Horarios flexibles',
  
  service3Title: 'Disponible 24/7',
  service3Desc: 'Servicio disponible 24 horas al día, 7 días a la semana. Siempre estamos listos para servirle, a cualquier hora.',
  service3Keywords: 'Transfer 24 Horas, Servicio 24/7, Siempre Disponible',
  service3Feature1: 'Emergencias',
  service3Feature2: 'Vuelos tardíos',
  service3Feature3: 'Flexibilidad total',
  
  service4Title: 'Licenciados y Asegurados',
  service4Desc: 'Todos nuestros vehículos y conductores están completamente licenciados y asegurados para su seguridad y tranquilidad.',
  service4Keywords: 'Taxi Licenciado Faro, Transfer Asegurado, Servicio Certificado',
  service4Feature1: 'Conductores certificados',
  service4Feature2: 'Vehículos inspeccionados',
  service4Feature3: 'Seguro integral',
  
  service5Title: 'Precios Low Cost',
  service5Desc: 'Ofrecemos los mejores precios del mercado sin comprometer la calidad del servicio. Descuentos especiales para ida y vuelta.',
  service5Keywords: 'Transfer Barato Algarve, Precio Low Cost, Descuento Transfer',
  
  service6Title: 'Conductores Profesionales',
  service6Desc: 'Conductores experimentados, licenciados y con conocimiento profundo del Algarve. Excelencia en el servicio garantizada.',
  service6Keywords: 'Conductor Profesional, Conductor Experimentado, Servicio Premium',
  
  // Why Choose FARWAYS
  whyChooseFarways: '¿Por Qué Elegir FARWAYS?',
  whyReason1Title: 'Transfers Low Cost Certificados',
  whyReason1Desc: 'Todos nuestros taxis están licenciados y cumplen con todas las regulaciones de transporte de pasajeros en Portugal.',
  whyReason2Title: 'Seguro Completo',
  whyReason2Desc: 'Cobertura de seguro total para pasajeros y equipaje en todos los transfers desde el Aeropuerto de Faro.',
  whyReason3Title: 'Precios Transparentes',
  whyReason3Desc: 'Sin costos ocultos. El precio que ve es el precio que paga. Descuentos especiales para viajes de ida y vuelta.',
  whyReason4Title: 'Reserva Online Fácil',
  whyReason4Desc: 'Reserve en 2 minutos. Confirmación inmediata por email. Cambios gratuitos hasta 24h antes.',
  
  // Fleet
  fleetTitle: 'Nuestra Flota',
  fleetSubtitle: 'Vehículos modernos y cómodos para todas tus necesidades de transporte',
  ourFleet: 'Nuestra Flota',
  fleetDescription: 'Vehículos modernos y cómodos para todas tus necesidades de transporte',
  fleetPassengers: 'Pasajeros',
  luggage: 'Equipaje',
  
  fleetEconomico: 'Económico',
  fleetEconomicoDesc: 'Ideal para viajes individuales o parejas',
  fleetConforto: 'Confort',
  fleetConfortoDesc: 'Perfecto para familias pequeñas',
  fleetSUV: 'SUV',
  fleetSUVDesc: 'Máximo confort y estilo',
  fleetMPV: 'MPV',
  fleetMPVDesc: 'Espacio extra para equipaje',
  fleetMinivan: 'Minivan',
  fleetMinivanDesc: 'Ideal para grupos y familias grandes',
  fleetMinibus: 'Minibus',
  fleetMinibusDesc: 'Para grupos grandes y eventos',
  
  fleetFeature1: 'Aire Acondicionado',
  fleetFeature2: 'Wi-Fi Gratuito',
  fleetFeature3: 'Conductor Profesional',
  fleetFeature4: 'Asientos de Cuero',
  fleetFeature5: 'Agua Gratuita',
  fleetFeature6: 'Asientos Premium',
  fleetFeature7: 'Sistema de Sonido',
  fleetFeature8: 'Espacio Extra',
  fleetFeature9: 'Puerto USB',
  fleetFeature10: 'Asientos Individuales',
  fleetFeature11: 'Entretenimiento',
  fleetFeature12: 'Espacio Premium',
  
  fleetExample1: 'Aeropuerto de Faro » Vilamoura',
  fleetExample2: 'Aeropuerto de Faro » Albufeira',
  fleetExample3: 'Aeropuerto de Faro » Carvoeiro',
  fleetExample4: 'Aeropuerto de Faro » Tavira',
  fleetExample5: 'Aeropuerto de Faro » Portimão',
  fleetExample6: 'Aeropuerto de Faro » Lagos',
  
  // About
  aboutTitle: 'Sobre FARWAYS VIAGENS',
  aboutSubtitle: 'Excelencia en transfers en Algarve durante más de 10 años',
  aboutDesc1: 'Somos una empresa especializada en transfers y transporte turístico en Algarve, con más de 15 años de experiencia en el sector. Nuestra misión es proporcionar viajes seguros, cómodos y puntuales a todos nuestros clientes.',
  aboutDesc2: 'Con una flota moderna y diversa, servimos el Aeropuerto de Faro y toda la región del Algarve, ofreciendo soluciones de transporte personalizadas para turistas, empresas y eventos especiales.',
  
  aboutFeature1: 'Conductores licenciados y experimentados',
  aboutFeature2: 'Flota moderna y bien mantenida',
  aboutFeature3: 'Precios competitivos y transparentes',
  aboutFeature4: 'Atención personalizada 24/7',
  
  aboutStat1: '5000+',
  aboutStat1Label: 'Clientes Satisfechos',
  aboutStat2: '15+',
  aboutStat2Label: 'Años de Experiencia',
  aboutStat3: '50+',
  aboutStat3Label: 'Vehículos en la Flota',
  aboutStat4: '24/7',
  aboutStat4Label: 'Disponibilidad',
  
  yearsLabel: 'Años de Experiencia',
  
  // Contact
  contactTitle: 'Contactos',
  contactSubtitle: 'Póngase en contacto con nosotros para más información o reservas',
  phone: 'Teléfono',
  email: 'Email',
  address: 'Dirección',
  schedule: 'Horario',
  scheduleText: '24 horas al día\n7 días a la semana',
  
  formTitle: 'Envíenos un Mensaje',
  nameLabel: 'Nombre',
  namePlaceholder: 'Su nombre',
  emailPlaceholder: 'su.email@ejemplo.com',
  phoneLabel: 'Teléfono',
  phonePlaceholder: '+351 912 345 678',
  subjectLabel: 'Asunto',
  subjectPlaceholder: 'Asunto del mensaje',
  messageLabel: 'Mensaje',
  messagePlaceholder: 'Su mensaje...',
  submitButton: 'Enviar Mensaje',
  successMessage: '¡Mensaje enviado con éxito!',
  errorMessage: 'Error al enviar el mensaje. Inténtelo de nuevo.',
  
  // Footer
  footerDescription: 'Servicios de transfer premium en el Algarve. Te conectamos con los mejores destinos con comodidad y seguridad.',
  quickLinks: 'Enlaces Rápidos',
  followUs: 'Síguenos',
  allRightsReserved: 'Todos los derechos reservados.',
  privacyPolicy: 'Política de Privacidad',
  termsOfService: 'Términos de Servicio',
  
  // Booking Engine
  bookingTitle: 'Planifique Su Viaje Con Nosotros',
  bookingSubtitle: 'Sencillo, rápido y sin complicaciones',
  from: 'Desde',
  to: 'Hasta',
  date: 'Fecha',
  time: 'Hora',
  passengers: 'Pasajeros',
  passengerSingular: 'Pasajero',
  passengerPlural: 'Pasajeros',
  returnTrip: 'Viaje de Vuelta',
  searchTransfers: 'Reservar',
  processing: 'Procesando...',
  bookingConfirmed: '¡Reserva confirmada!',
  reservationNumber: 'Número de reserva',
  pdfSentTo: 'PDF enviado a',
  bookingError: 'Error al crear la reserva. Por favor, inténtelo de nuevo.',
  fullName: 'Nombre completo',
  destination: 'Destino',
  
  // Child Seats
  childSeats: 'Asientos para Niños',
  childSeat0to1: '0-1 años (€7)',
  childSeat1to3: '1-3 años (€6)',
  childSeat5to12: '5-12 años (€4)',
  childSeat0to1Short: '0-1 años',
  childSeat1to3Short: '1-3 años',
  childSeat5to12Short: '5-12 años',
  seat: 'asiento',
  seats: 'asientos',
  childSeatsIncluded: 'Asientos para niños incluidos',
  
  // Observations
  observations: 'Observaciones',
  observationsPlaceholder: 'Ej: 2 palos de golf, equipaje extra, etc.',
  
  // Privacy Policy
  privacyPolicyTitle: 'Política de Privacidad',
  privacyLastUpdated: 'Última actualización',
  privacyIntro: 'FARWAYS VIAGENS respeta su privacidad y está comprometida a proteger sus datos personales. Esta política de privacidad explica cómo recopilamos, usamos y protegemos su información personal de acuerdo con el Reglamento General de Protección de Datos (RGPD).',
  acceptPrivacyPart1: 'He leído y acepto la',
  acceptPrivacyPart2: '',
  mustAcceptPrivacy: 'Debe aceptar la política de privacidad para continuar.',
  
  // Terms of Service
  termsTitle: 'Términos y Condiciones de Servicio',
  termsLastUpdated: 'Última actualización: Enero 2025',
  
  termsSection1Title: '1. Aceptación de los Términos',
  termsSection1Text1: 'Al utilizar el sitio web de FARWAYS y nuestros servicios de transfer, usted acepta estos Términos y Condiciones de Servicio. Si no está de acuerdo con alguna parte de estos términos, no debe utilizar nuestros servicios.',
  termsSection1Text2: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en el sitio web.',
  
  termsSection2Title: '2. Servicios Ofrecidos',
  termsSection2Text1: 'FARWAYS ofrece servicios de transfer premium en el Algarve, incluyendo:',
  termsSection2Item1: 'Transfers desde y hacia aeropuertos',
  termsSection2Item2: 'Transfers entre ciudades y hoteles',
  termsSection2Item3: 'Servicios de transporte ejecutivo',
  termsSection2Item4: 'Tours personalizados',
  termsSection2Item5: 'Reservas a través del sistema online con confirmación automática',
  
  termsSection3Title: '3. Reservas y Confirmaciones',
  termsSection3Text1: 'Al realizar una reserva a través de nuestro sistema online:',
  termsSection3Item1: 'Recibirá un número de reserva único y un PDF de confirmación por email',
  termsSection3Item2: 'La reserva se considera confirmada después del envío del email de confirmación',
  termsSection3Item3: 'Debe presentar el número de reserva al conductor en el momento del servicio',
  termsSection3Item4: 'Es responsable de proporcionar información correcta y completa (nombre, email, teléfono, lugares y horarios)',
  
  termsSection4Title: '4. Cancelaciones y Cambios',
  termsSection4Text1: 'Política de cancelación y cambios:',
  termsSection4Item1: 'Cancelaciones con más de 24 horas de antelación: reembolso total',
  termsSection4Item2: 'Cancelaciones entre 12-24 horas: reembolso del 50%',
  termsSection4Item3: 'Cancelaciones con menos de 12 horas: sin reembolso',
  termsSection4Item4: 'Los cambios de fecha/hora deben solicitarse con al menos 24 horas de antelación',
  
  termsSection5Title: '5. Pago',
  termsSection5Text1: 'El pago se puede realizar con tarjeta de crédito/débito o en efectivo directamente al conductor. Los precios mostrados incluyen todos los impuestos aplicables.',
  termsSection5Text2: 'Nos reservamos el derecho de ajustar los precios sin previo aviso, pero los precios confirmados en el momento de la reserva serán respetados.',
  
  termsSection6Title: '6. Responsabilidades del Cliente',
  termsSection6Text1: 'El cliente se compromete a:',
  termsSection6Item1: 'Estar presente en el lugar de recogida a la hora programada (recomendamos 10 minutos antes)',
  termsSection6Item2: 'Informar sobre equipaje extra o necesidades especiales en el momento de la reserva',
  termsSection6Item3: 'Comportarse respetuosamente con el conductor y mantener el vehículo limpio',
  
  termsSection7Title: '7. Limitación de Responsabilidad',
  termsSection7Text1: 'FARWAYS no se responsabiliza por retrasos causados por condiciones de tráfico, condiciones meteorológicas adversas u otros factores fuera de nuestro control.',
  termsSection7Text2: 'No nos responsabilizamos por objetos personales dejados en los vehículos, aunque hacemos todos los esfuerzos para devolver los artículos encontrados.',
  
  termsSection8Title: '8. Protección de Datos',
  termsSection8Text1: 'Sus datos personales se tratan de acuerdo con nuestra Política de Privacidad y el Reglamento General de Protección de Datos (RGPD).',
  termsSection8Text2: 'La información proporcionada durante la reserva se almacena de forma segura en nuestro sistema y se utiliza exclusivamente para la prestación del servicio.',
  
  termsSection9Title: '9. Ley Aplicable',
  termsSection9Text1: 'Estos términos se rigen por la ley portuguesa. Cualquier disputa se resolverá en los tribunales competentes de Portugal.',
  
  termsSection10Title: '10. Contacto',
  termsSection10Text1: 'Para preguntas sobre estos Términos y Condiciones, contáctenos:',
  
  contactInfo: 'Información de Contacto',
  backToHome: 'Volver al Inicio',
  
  // Legal Links
  complaintsBook: 'Libro de Reclamaciones',
  arbitrationCenter: 'Centro de Arbitraje',
  cookiePolicy: 'Política de Cookies',
  name: 'Nombre',
  
  // Pricing Page
  pricingTitle: 'Tarifas de Transfers',
  pricingSubtitle: 'Precios transparentes y fijos para todas las rutas del Algarve',
  pricingDescription: 'Consulte nuestros precios competitivos para transfers desde el Aeropuerto de Faro a los principales destinos del Algarve y España.',
  route: 'Ruta',
  economico: 'Económico',
  conforto: 'Confort',
  suv: 'SUV',
  mpv: 'MPV',
  minivan: 'Minivan',
  minibus: 'Minibús',
  luxo: 'Lujo',
  bookThisRoute: 'Reservar Esta Ruta',
  pricesIncludeVAT: 'Todos los precios incluyen IVA',
  noHiddenFees: 'Sin costos ocultos',
  fixedPrices: 'Precios fijos garantizados',
  allVehiclesInclude: 'Todos los vehículos incluyen',
  professionalDriver: 'Conductor profesional',
  freeWifi: 'Wi-Fi gratuito',
  airConditioning: 'Aire acondicionado',
  freeWater: 'Agua gratuita',
  flightMonitoring: 'Monitoreo de vuelos',
  meetAndGreet: 'Servicio meet & greet',
  pricing: 'Tarifas',
  vehicleType: 'Tipo de Vehículo',
  totalValue: 'Valor Total',
  discountApplied: 'Descuento del 10% aplicado (ida y vuelta)',
  action: 'Acción',
  importantInfo: 'Información Importante',
  oneWayPrices: 'Precios válidos para viajes de ida',
  roundTripDiscount: 'Viajes de ida y vuelta: descuento del 10%',
  pricesIncludeTax: 'Todos los precios incluyen IVA a la tasa legal',
  noWaitingCosts: 'Sin costos de espera en el aeropuerto',
  searchRoute: 'Buscar ruta por destino...',
  noRoutesFound: 'No se encontraron rutas',
  routeFound: 'ruta encontrada',
  routesFound: 'rutas encontradas',
  tryDifferentSearch: 'Intente buscar otro destino o limpie la búsqueda para ver todas las rutas.',
  clearSearch: 'Limpiar Búsqueda',
  
  // Winter Discount
  winterDiscount: '❄️ Descuento de Invierno - 30% OFF',
  winterDiscountDescription: 'Válido de Noviembre a Marzo + 10% extra en viajes de ida y vuelta',
  winterDiscountActive: 'Descuento de invierno del 30% ya aplicado en los precios mostrados',
  winterDiscountApplied: 'Descuento de invierno del 30% aplicado',
  
  // Booking Engine Additional
  routeNotInTable: 'Ruta no encontrada en la tabla de precios',
  contactForQuote: 'Contáctenos para un presupuesto personalizado para esta ruta.',
  
  // 404 Page
  notFoundTitle: 'Página No Encontrada',
  notFoundSubtitle: 'Parece que esta ruta no existe en nuestro mapa',
  notFoundDescription: 'La página que busca puede haber sido movida o no existe. ¡Pero no se preocupe, podemos llevarlo de vuelta al destino correcto!',
  goHome: 'Volver al Inicio',
  viewPricing: 'Ver Tarifas',
  contactUs: 'Contáctenos',
  error404: 'Error 404',
  
  // Contact Page Additional
  contactInformation: 'Información de Contacto',
  howToGetHere: 'Cómo Llegar',
  findUsEasily: 'Encuéntrenos fácilmente en el centro de Faro',
  sendUsMessage: 'Envíenos un Mensaje',
  fillFormBelow: 'Complete el formulario a continuación y nos pondremos en contacto con usted en breve.',
  maxCharacters: 'Máximo 500 caracteres',
  onlineComplaintsBook: 'Libro de Reclamaciones Online',
  algarveArbitrationCenter: 'Centro de Arbitraje de Consumo del Algarve',
  
  // Testimonials
  testimonialsTitle: 'Lo Que Dicen Nuestros Clientes',
  testimonialsSubtitle: 'Más de 5000 clientes satisfechos confían en nuestros servicios de transfer',
  testimonial1: '¡Servicio impecable! El conductor me estaba esperando en el aeropuerto con un cartel con mi nombre. El coche era lujoso y muy cómodo. Lo recomiendo encarecidamente para quienes buscan calidad y puntualidad.',
  testimonial2: 'He utilizado los servicios de FARWAYS varias veces para viajes de negocios. Siempre puntuales, profesionales y con vehículos en excelente estado. Es mi primera opción para transfers en el Algarve.',
  testimonial3: 'Hicimos un viaje en familia y reservamos una minivan. Espacio más que suficiente para todos nosotros y el equipaje. El conductor fue muy amable y nos dio excelentes consejos sobre la región. ¡Experiencia fantástica!',
  testimonial4: 'Excelente relación calidad-precio. El servicio superó mis expectativas. Conductor muy educado y conocedor de la región. Sin duda volveré a utilizarlo.',
  testimonial5: '¡Servicio de primera clase! Reservé un transfer del aeropuerto al hotel y todo fue perfecto. El vehículo era nuevo y muy limpio. Me sentí muy segura durante todo el viaje.',
  testimonial6: 'Lo utilizo regularmente para viajes de negocios. La puntualidad es impresionante y los conductores son siempre muy profesionales. El mejor servicio de transfers que he experimentado en Portugal.',
  testimonialDate1: 'Marzo 2024',
  testimonialDate2: 'Febrero 2024',
  testimonialDate3: 'Enero 2024',
  testimonialDate4: 'Diciembre 2023',
  testimonialDate5: 'Noviembre 2023',
  testimonialDate6: 'Octubre 2023',
  averageRating: 'Calificación Media',
  happyClients: 'Clientes Satisfechos',
  verified: 'Verificado',
  awards: 'Premios',
  
  // FAQ Page
  faqTitle: 'Preguntas Frecuentes',
  faqSubtitle: 'Encuentre respuestas rápidas a las preguntas más comunes sobre nuestros servicios de transfer en el Algarve',
  
  // FAQ Categories
  faqCategoryAll: 'Todas',
  faqCategoryReservas: 'Reservas y Cambios',
  faqCategoryAeroporto: 'Aeropuerto y Encuentro',
  faqCategoryBagagem: 'Equipaje y Extras',
  faqCategoryServico: 'Tipos de Servicio',
  faqCategoryPagamento: 'Pago y Precios',
  faqCategorySeguranca: 'Seguridad y Confianza',
  
  // FAQ Questions and Answers - Reservas
  faqQuestion1: '¿Puedo hacer cambios en mi reserva?',
  faqAnswer1: 'Sí, puede cambiar su reserva hasta 24 horas antes de la hora de recogida programada. Para hacer cambios, acceda a la sección "Mi Reserva" en nuestro sitio web usando los datos de su email de confirmación. Si no puede acceder en línea, contáctenos a través del formulario de contacto o llame al +351 937 545 000.',
  
  faqQuestion2: '¿Cómo puedo cancelar mi reserva?',
  faqAnswer2: 'Puede cancelar a través de la sección "Mi Reserva" de nuestro sitio web, utilizando los datos del email de confirmación. Política de cancelación:\n\n• Más de 24h de antelación: reembolso total\n• Entre 12-24h: reembolso del 50%\n• Menos de 12h: sin reembolso\n\nSi no puede acceder en línea, contáctenos directamente.',
  
  faqQuestion3: '¿Y si mi vuelo se retrasa o se cancela?',
  faqAnswer3: '¡No se preocupe! Monitoreamos todos los vuelos automáticamente. Si su vuelo se retrasa, su conductor será informado y ajustará la hora de recogida. No hay costos adicionales por retrasos de vuelo. La actualización está sujeta a la disponibilidad del conductor.',
  
  faqQuestion4: 'Mis datos de vuelo han cambiado, ¿necesito informar?',
  faqAnswer4: 'Sí, por favor envíe el nuevo horario de vuelo lo antes posible a través de la sección "Mi Reserva" o contáctenos directamente. Si el embarque es en menos de 24 horas, llame urgentemente al +351 937 545 000 para asegurar que el conductor esté informado.',
  
  // FAQ Questions and Answers - Aeroporto
  faqQuestion5: '¿Cuál es el punto de encuentro en el aeropuerto?',
  faqAnswer5: 'El conductor estará esperándole en la sala de llegadas del Aeropuerto de Faro, sosteniendo un cartel con su nombre. La ubicación exacta se confirmará en el email de confirmación de la reserva. Si no encuentra al conductor, llame al número de emergencia proporcionado en el email.',
  
  faqQuestion6: '¿Cuánto tiempo espera el conductor en el aeropuerto?',
  faqAnswer6: 'El conductor espera hasta 60 minutos después de la hora de aterrizaje programada sin costo adicional. Este tiempo es suficiente para recoger equipaje y pasar por la aduana. Si necesita más tiempo, contáctenos con anticipación.',
  
  faqQuestion7: '¿Cómo identifico al conductor?',
  faqAnswer7: 'El conductor tendrá un cartel con su nombre completo (como se indica en la reserva) y uniforme de FARWAYS. Todos nuestros conductores son profesionales licenciados e identificados. En caso de duda, siempre puede llamar al número de emergencia proporcionado en el email de confirmación.',
  
  // FAQ Questions and Answers - Bagagem
  faqQuestion8: '¿Cuál es el tamaño de una maleta mediana y pequeña?',
  faqAnswer8: 'Maleta mediana: aproximadamente 65-70 cm (26-27 pulgadas) - equipaje facturado estándar\nMaleta pequeña: alrededor de 35 cm (14 pulgadas) - mochila o equipaje de mano\n\nSi tiene equipaje grande, especial (palos de golf, bicicletas, etc.) o en cantidad superior al estándar, indique en el campo "Observaciones" al hacer la reserva para garantizar el vehículo adecuado.',
  
  faqQuestion9: '¿Proporcionan sillas para niños?',
  faqAnswer9: '¡Sí! Proporcionamos sillas para niños y bebés bajo solicitud:\n\n• 0-1 años (Grupo 0+): €7\n• 1-3 años (Grupo 1): €6\n• 5-12 años (Grupo 2/3): €4\n\nPuede solicitar en la sección "Asientos para Niños" durante la reserva. Las sillas cumplen con todas las normas de seguridad europeas.',
  
  faqQuestion10: '¿Puedo llevar equipaje extra?',
  faqAnswer10: 'Sí, pero es importante informar en la reserva. Cada tipo de vehículo tiene capacidad específica de equipaje. Si tiene más equipaje que el estándar, podemos sugerir un vehículo más grande u organizar transporte adicional. Indique siempre en el campo "Observaciones" artículos especiales como equipo deportivo, cochecitos de bebé, etc.',
  
  // FAQ Questions and Answers - Serviço
  faqQuestion11: '¿Compartiré el vehículo con otros pasajeros?',
  faqAnswer11: '¡No! Todos nuestros servicios son transfers PRIVADOS. Usted y su grupo serán los únicos ocupantes del vehículo. No hacemos transfers compartidos. El vehículo es exclusivamente suyo durante todo el viaje, garantizando comodidad, privacidad y puntualidad.',
  
  faqQuestion12: '¿Qué está incluido en el servicio de transfer?',
  faqAnswer12: 'Nuestro servicio incluye:\n\n✅ Conductor profesional licenciado\n✅ Vehículo limpio y cómodo\n✅ Aire acondicionado\n✅ Wi-Fi gratuito\n✅ Agua gratuita\n✅ Monitoreo de vuelos\n✅ Servicio meet & greet en el aeropuerto\n✅ Asistencia con equipaje\n✅ Sin costos de espera (hasta 60 min en aeropuerto)\n✅ Todos los impuestos incluidos',
  
  faqQuestion13: '¿El servicio me lleva directamente al hotel?',
  faqAnswer13: '¡Sí! Nuestro servicio de transfer privado le lleva directamente desde el aeropuerto hasta la puerta de su hotel, apartamento o cualquier otra dirección en el Algarve. Sin paradas intermedias, sin esperas. Servicio puerta a puerta con máxima comodidad y rapidez.',
  
  // FAQ Questions and Answers - Pagamento
  faqQuestion14: '¿Qué formas de pago se aceptan?',
  faqAnswer14: 'Aceptamos:\n\n💳 Tarjeta de crédito/débito (Visa, Mastercard, American Express)\n💰 Efectivo (Euros) directamente al conductor\n🌐 PayPal (pago en línea)\n💼 Transferencia bancaria (para reservas empresariales)\n\nEl pago en línea es seguro y procesado a través de plataforma certificada.',
  
  faqQuestion15: '¿Los precios incluyen todas las tasas?',
  faqAnswer15: '¡Sí! Los precios mostrados en nuestro sitio web son FINALES e incluyen:\n\n✅ IVA a tasa legal\n✅ Todas las tasas e impuestos\n✅ Combustible\n✅ Peajes (si aplica)\n✅ Seguro completo\n✅ Sin costos ocultos\n\n¡El precio que ve es el precio que paga. Garantizado!',
  
  faqQuestion16: '¿Hay descuento para viajes de ida y vuelta?',
  faqAnswer16: '¡Sí! Ofrecemos un 10% de descuento automático en todas las reservas de ida y vuelta. Además, tenemos una promoción especial de invierno (Noviembre a Marzo) con 30% de descuento + 10% adicional en viajes de ida y vuelta. Los descuentos se aplican automáticamente al momento de la reserva.',
  
  // FAQ Questions and Answers - Segurança
  faqQuestion17: '¿Los conductores están licenciados?',
  faqAnswer17: '¡Sí! Todos nuestros conductores son:\n\n✅ Licenciados profesionalmente (TVDE/Taxi)\n✅ Con experiencia mínima de 5 años\n✅ Certificados por la autoridad de transporte\n✅ Con conocimiento profundo del Algarve\n✅ Fluidos en Portugués, Inglés y Español\n✅ Formados en atención al cliente\n✅ Con registro criminal limpio',
  
  faqQuestion18: '¿Los vehículos tienen seguro?',
  faqAnswer18: '¡Sí! Todos nuestros vehículos tienen:\n\n✅ Seguro contra todo riesgo\n✅ Seguro de pasajeros\n✅ Inspecciones técnicas al día\n✅ Mantenimiento regular\n✅ Limpieza y desinfección después de cada servicio\n✅ Equipo de seguridad completo\n\nSu seguridad es nuestra máxima prioridad.',
  
  faqQuestion19: '¿Cómo puedo estar seguro de que la reserva es legítima?',
  faqAnswer19: 'FARWAYS es una empresa registrada y licenciada:\n\n📋 NIPC: 505413850\n📋 RNAVT: 8586 (Registro Nacional de Agentes de Viajes)\n📋 Licencia de transporte válida\n📋 Más de 15 años de experiencia\n📋 +5000 clientes satisfechos\n📋 Reseñas verificadas\n\nRecibirá un email de confirmación inmediato con todos los detalles y número de reserva. Siempre puede verificar la legitimidad contactándonos directamente.',
  
  // FAQ Additional
  faqNoResults: 'No se encontraron preguntas en esta categoría',
  faqStillHaveQuestions: '¿Todavía tiene preguntas?',
  faqContactText: 'Nuestro equipo está disponible 24/7 para ayudar',
  faqContactButton: 'Contáctenos',
};
